import { A } from '@ember/array';
import Service, { inject as service } from '@ember/service';
/**
 * this service make sure that registered pickers are open one at a time
 *
 * you put "register" in init()
 * "unregister" in willDestroy() - only if picker isn't singleton
 * "open" in "open" or similar callback
 */

export default class PickersService extends Service {
  @service dynamicPopups;

  _registered = A();

  register({ name, close }) {
    this._registered.pushObject({ name, close });
  }

  // if picker is singleton, no need to unregister
  unregister({ name }) {
    const found = this._registered.find((el) => el.name === name);
    if (found) this._registered.removeObject(found);
  }

  open({ name }) {
    this._registered
      .filter((el) => el.name !== name)
      .forEach((el) => {
        el.close();
      });
  }
}
